import { HelloCoreBase } from "./hello.core.base"


export class HelloCore extends HelloCoreBase {

}